import React, { useEffect, useRef } from "react";
import { Controller } from "react-hook-form";

import Select from "react-select";

import { dynamicFormStyles } from "./dynamicFormStyles";
import styles from "./dynamicForm.module.css";

const DynamicForm = ({
  fields,
  control,
  setValue,
  initialValues,
  stylesFromParent,
  onCustomButtonClick,
}) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      fields.forEach((field) => {
        if (initialValues && Object.keys(initialValues).length > 0) {
          setValue(field.id, initialValues[field.id] || "");
        }
      });
      isFirstRender.current = false;
    }
  }, [initialValues, fields, setValue]);

  return (
    <div className={stylesFromParent.formContainer}>
      {fields.map((field) => (
        <div
          key={field.id}
          className={`${styles.fieldContainer} ${
            stylesFromParent[`field-${field.id}`]
          }`}
        >
          {field.type !== "button" && (
            <div className={styles["label-name"]}>
              <label className={styles.label}>{field.label}</label>
              <p>{field.isRequired ? "*" : ""}</p>
            </div>
          )}
          {field.type === "input" && (
            <Controller
              disabled={field.disabled}
              name={field.id}
              control={control}
              defaultValue={initialValues ? initialValues[field.id] : undefined}
              rules={{
                ...(field.validation ? field.validation() : null),
                ...(field.isRequired
                  ? { required: "Заполните обязательное поле" }
                  : { required: "" }),
              }}
              render={({ field: inputProps, fieldState }) => (
                <>
                  <div className={styles["input-field"]}>
                    <input
                      type="text"
                      {...inputProps}
                      onChange={(val) =>
                        inputProps.onChange(
                          field.upperCase
                            ? val.target.value.toUpperCase()
                            : val.target.value.replace(",", "."),
                        )
                      }
                      value={
                        field.upperCase && inputProps.value
                          ? inputProps.value.toString().toUpperCase()
                          : inputProps.value
                      }
                      placeholder={field.placeholder}
                      className={styles.input}
                    />
                    {field.button && (
                      <button
                        className={`${styles["dynamic-form-button"]}`}
                        type="button"
                        onClick={() => onCustomButtonClick(field.button.id)}
                      >
                        {field.button.searchIcon && (
                          <span
                            data-key={inputProps.key}
                            className={styles["search-icon"]}
                          ></span>
                        )}
                        <span>{field.button.label}</span>
                      </button>
                    )}
                  </div>
                  {fieldState.error && (
                    <span className={styles.error}>
                      {fieldState.error.message}
                    </span>
                  )}
                </>
              )}
            />
          )}
          {field.type === "date" && (
            <Controller
              name={field.id}
              control={control}
              defaultValue={initialValues ? initialValues[field.id] : ""}
              rules={{
                ...(field.validation ? field.validation() : null),
                ...(field.isRequired
                  ? { required: "Заполните обязательное поле" }
                  : { required: "" }),
              }}
              render={({ field, fieldState }) => (
                <>
                  <input
                    type="date"
                    {...field}
                    placeholder={field.placeholder}
                    className={styles.date}
                  />
                  {fieldState.error && (
                    <span className={styles.error}>
                      {fieldState.error.message}
                    </span>
                  )}
                </>
              )}
            />
          )}
          {field.type === "select" && (
            <Controller
              name={field.id}
              control={control}
              defaultValue={initialValues ? initialValues[field.id] : ""}
              rules={{
                ...(field.validation ? field.validation() : null),
                ...(field.isRequired
                  ? { required: "Заполните обязательное поле" }
                  : { required: "" }),
              }}
              render={({ field: { onChange, value, ref }, fieldState }) => (
                <>
                  <Select
                    isDisabled={field.disabled}
                    inputRef={ref}
                    value={
                      value
                        ? field.options &&
                          field.options.find((opt) => opt.value === value.value)
                        : null
                    }
                    onChange={(val) => onChange(val)}
                    options={field.options}
                    placeholder={field.placeholder}
                    styles={dynamicFormStyles}
                    className={styles.select}
                  />
                  {fieldState.error && (
                    <span className={styles.error}>
                      {fieldState.error.message}
                    </span>
                  )}
                </>
              )}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default DynamicForm;
